import { render, staticRenderFns } from "./mobile-scn.vue?vue&type=template&id=67234e63&scoped=true&"
import script from "./mobile-scn.vue?vue&type=script&lang=js&"
export * from "./mobile-scn.vue?vue&type=script&lang=js&"
import style0 from "./mobile-scn.vue?vue&type=style&index=0&id=67234e63&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67234e63",
  null
  
)

export default component.exports